import React from "react";
import { useNavigate } from "react-router";
import styles from "./MakeDonation.module.css";
import { CiHeart } from "react-icons/ci";
import { ButtonOrange } from "../../components/Button";

function MakeDonation() {
  const navigate = useNavigate();
  return (
    <section className={styles.makeDonation}>
      <div className={styles.makeDonationContainer}>
        <h1 className={styles.makeDonationTitle}>
          Ready to Make a Difference?
        </h1>

        <p className={styles.makeDonationDescription}>
          Your support can help us continue our mission to support Mississippi's
          roadworkers and their families.
        </p>
        <ButtonOrange onClick={() => navigate("/donate")}>
          Make a Donation <CiHeart />
        </ButtonOrange>
      </div>
    </section>
  );
}

export default MakeDonation;
